import { S as SocialLoginResponseStatus } from '../../chuck/SocialLoginResponseStatus-BP1cpX8W.js';

var generateRandomString = function(length) {
    var characters = 'CDEHKMPRTUWXY012458'; // distinguishable characters (same as crypto-random-string)
    var array = new Uint8Array(length);
    crypto.getRandomValues(array);
    return Array.from(array, function(byte) {
        return characters[byte % characters.length];
    }).join('');
};
var openLinePopup = function(config, state) {
    var height = 600;
    var width = 400;
    var top = window.innerHeight / 2 - height / 2;
    var left = window.innerWidth / 2 - width / 2;
    window.name = 'wwwagodacom';
    var lineAuthUrl = 'https://access.line.me/oauth2/v2.1/authorize';
    var popupUrl = new URL(lineAuthUrl);
    popupUrl.searchParams.append('response_type', 'code');
    popupUrl.searchParams.append('client_id', config.clientId);
    popupUrl.searchParams.append('scope', !!config.scope ? config.scope : '');
    popupUrl.searchParams.append('state', state);
    popupUrl.searchParams.append('redirect_uri', config.redirectUri);
    popupUrl.searchParams.append('bot_prompt', 'normal');
    if (config.appId === 'dictator' || config.appId === 'dspa') {
        popupUrl.searchParams.append('initial_amr_display', 'lineqr');
    }
    if (config.appId === 'androidAgoda' || config.appId === 'iosAgoda') {
        popupUrl.searchParams.append('initial_amr_display', 'lineqr');
        popupUrl.searchParams.append('switch_amr', 'false');
        popupUrl.searchParams.append('disable_auto_login', 'true');
        popupUrl.searchParams.append('disable_ios_auto_login', 'true');
    }
    return window.open(popupUrl.toString(), '_blank', "height=" + height + ",width=" + width + ",menubar=0,status=0,top=" + top + ",left=" + left);
};
var LineSdkLogin = function(config) {
    return new Promise(function(resolve) {
        var cleanup = function cleanup() {
            if (!!lineWindow && !lineWindow.closed) {
                try {
                    lineWindow.close();
                } catch (e) {
                    console.error('Failed to close popup window:', e);
                }
            }
            if (windowWatcher) {
                window.clearInterval(windowWatcher);
            }
            // Close the channel after a delay to ensure message processing
            setTimeout(function() {
                try {
                    channel.close();
                } catch (e) {
                    console.error('Failed to close BroadcastChannel:', e);
                }
            }, 1000);
        };
        var state = generateRandomString(10);
        var time = Date.now();
        var channel = new BroadcastChannel('line_login_channel');
        var isResolved = false;
        // Set up BroadcastChannel listener - this is the only message handling mechanism
        channel.onmessage = function(event) {
            var _event_data = event.data, code = _event_data.code, source = _event_data.source;
            if (source === 'lineCallback' && !isResolved) {
                isResolved = true;
                cleanup();
                if (code && code !== 'undefined' && code !== 'null') {
                    return resolve({
                        code: code,
                        status: SocialLoginResponseStatus.Success
                    });
                } else {
                    return resolve({
                        status: SocialLoginResponseStatus.Error,
                        error: 'nocode'
                    });
                }
            }
        };
        var lineWindow = openLinePopup(config, state);
        // Window watcher to detect if popup is closed without successful login
        var windowWatcher = 0;
        try {
            windowWatcher = window.setInterval(function() {
                if (!lineWindow || lineWindow.closed) {
                    if (!isResolved) {
                        isResolved = true;
                        cleanup();
                        var closeTime = Date.now();
                        return resolve({
                            status: SocialLoginResponseStatus.Error,
                            error: "window_closed " + (closeTime - time)
                        });
                    }
                }
            }, 10000);
        } catch (error) {
            if (!isResolved) {
                isResolved = true;
                cleanup();
                return resolve({
                    status: SocialLoginResponseStatus.Error,
                    error: "" + error
                });
            }
        }
    });
};

export { LineSdkLogin };
